export default __webpack_public_path__ + "static/media/grow.2492d34a.png";